/*
* Salla Qunatity Input Component: quantity input with increase & decrease buttons.
* You can use these classes to target the elements in the component.
*/

.s-quantity-input{
  &-input{
    
  }
  &-button{

  }
}